export const SAVE_ABOUT = 'SAVE_ABOUT';
export const SAVE_ABOUT_SUCCESS = 'SAVE_ABOUT_SUCCESS';
export const SAVE_ABOUT_FAILURE = 'SAVE_ABOUT_FAILURE';
export const ADD_ABOUT_TO_THE_LIST = 'ADD_ABOUT_TO_THE_LIST';
export const UPDATE_ABOUT_IN_THE_LIST = 'UPDATE_ABOUT_IN_THE_LIST';



// WEBPACK FOOTER //
// ./src/modules/AboutForm/actionTypes.js